module.exports = __webpack_public_path__ + "img/file.af6562f7.svg";